"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebianDistroSDKProvider = void 0;
const GenericDistroSDKProvider_1 = require("./GenericDistroSDKProvider");
class DebianDistroSDKProvider extends GenericDistroSDKProvider_1.GenericDistroSDKProvider {
    constructor(distroVersion, context, utilContext, executor = null) {
        super(distroVersion, context, utilContext, executor);
    }
    dotnetPackageExistsOnSystem(fullySpecifiedDotnetVersion, installType) {
        const _super = Object.create(null, {
            dotnetPackageExistsOnSystem: { get: () => super.dotnetPackageExistsOnSystem }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.injectPMCFeed(fullySpecifiedDotnetVersion, installType);
            return _super.dotnetPackageExistsOnSystem.call(this, fullySpecifiedDotnetVersion, installType);
        });
    }
}
exports.DebianDistroSDKProvider = DebianDistroSDKProvider;
//# sourceMappingURL=DebianDistroSDKProvider.js.map